<template>
  <div>
    <div class="banner">
      <div>
        <span>{{ $t('faq.banner') }}</span>
        <p class="pc">{{ $t('faq.banner1') }}</p>
        <p class="mobile" v-html="$t('faq.banner2')"></p>
      </div>

    </div>
    <div class="section-wrap ">
      <div class="c-999 program-label">
        <span @click="routerSkip('/')">{{ $t('header.nav1') }}</span>  >  <span @click="routerSkip('/contact')">{{ $t('header.nav6') }}</span>  >  <span class="c-666">{{ $t('header.nav6_1') }}</span>
      </div>
      <div>
        <ul class="pro-ul">
          <li v-for="(item,idx) in list[listQuery.page-1]" :class="item.show?'active':''">
            <div class="pro-Q" @click="item.show=!item.show;$forceUpdate()">
              {{item.Q}}
              <img class="fr" v-show="item.show" src="@/assets/images/public/icon-arrow_05.png"/>
<div class="fr" v-show="!item.show">
  <img class="fr hover-default" src="@/assets/images/public/icon-arrow_10.png"/>
  <img class="fr hover"   src="@/assets/images/public/icon-arrow_08.png"/>
</div>


            </div>
            <div class="pro-A" v-show="item.show" v-html=" item.A ">
             
            </div>
          </li>
        </ul>
        <div class="pagination clearfix">

          <a-pagination :class="$i18n.locale" v-model="listQuery.page" :page-size="listQuery.size" :total="listQuery.total" show-less-items />
        </div>
      </div>
    </div>



  </div>
</template>

<script>

  export default {
    name: 'sales',
    data () {
      return { listQuery:{
              size:10,
              page:1,
              totalPage:1,
              total:7
          },
  list:[[
      {show:true,Q:this.$t('faq.q1'),A:this.$t('faq.p1'),},
      {show:true,Q:this.$t('faq.q2'),A:this.$t('faq.p2'),},
      {show:true,Q:this.$t('faq.q3'),A:this.$t('faq.p3'),},
      {show:true,Q:this.$t('faq.q4'),A:this.$t('faq.p4'),},
    ]]

      }
    }
  }
</script>
<style lang="stylus" scoped>
  @import "~@/assets/css/public.styl"

  .realize-more
    user-select none;cursor pointer
  h2,h3,h4,h5,h6,p{
    margin: 0
  }

  .banner{height:280px;background :url("~@/assets/images/contact/pro-banner.jpg") no-repeat center/auto 100%;
  p{font-size:.16rem;    padding-top: .08rem;}
  }
  .pro-ul{font-size :.16rem;margin-bottom .3rem;
    li{border-top:1px solid #e5e5e5;
    &.active+li{border:0;}
  &:first-child{border:0;}}
    .pro-Q{color:$standardColor;padding:0.25rem .5rem; background #fff;cursor :pointer;font-weight:bold;
    img{margin :.08rem 0;width:.14rem;height:auto;}
  .hover{display:none;}

  }

    .pro-A{color:#666;padding:0.28rem .5rem;background #fbfbfb;line-height .32rem;}
  }
  .pagination{margin-bottom:1.9rem;}
  @media screen and (min-width: 769px){
      .pro-Q{
          &:hover{ .hover{display:block;}.hover-default{display:none;}}
      }
  }
  @media screen and (max-width: 768px){
    .section-wrap{padding:0;}
    .banner{height:3.75rem;background :url("~@/assets/images/contact/m-pro-banner.jpg") no-repeat center/cover;
    p{font-size:.2rem;padding-top: .2rem;}}
    .pro-ul{font-size :.26rem;margin-bottom .8rem;
      .pro-Q{padding:0.3rem .24rem;
        img{width:.27rem;height:auto;}

      }
      .pro-A{line-height:.56rem;padding .24rem;}
    }
    .pagination{margin-bottom:.88rem;}
  }
</style>
<style >
  body{background :#f8f8f8}
  </style>
